import { FC } from "react";
import { useTranslation } from "react-i18next";
import { AdminFormFieldSubmit } from "../../../components/admin/formFields";
import svgIcons from "../../../assets/svg/svgIcons";
import ModalPreviousSaveConfirmation from "../configuration/modalPreviousSaveConfirmation";
import { setModalsData, TModalsState } from "../../../api/store/commonSlice";
import { useDispatch, useSelector } from "react-redux";
import ModalRestoreDefaultConfirmation from "../configuration/modalRestoreDefaultConfirmation";

interface HeaderViewProps {
  heading: string;
  handleSave: () => void;
  handleSaveAndNext: () => void;
  handlePrevious: () => void;
  handleLeftNavigation: () => void;
  handleRestoreToDefault: () => void;
  disabled?: boolean;
  index?: number;
}

const HeaderView: FC<HeaderViewProps> = ({
  heading,
  handleSave,
  handleSaveAndNext,
  handlePrevious,
  handleLeftNavigation,
  handleRestoreToDefault,
  disabled = false,
  index = 0,
}) => {
  const { t: tMain } = useTranslation();
  const modalsState: TModalsState = useSelector(
    (state: any) => state.commonReducer.modals
  );
  const dispatch = useDispatch();
  return (
    <div className="flex justify-between items-center pb-2">
      <h1 className="font-bold text-xl leading-none tracking-normal text-accent-blue-dark text-center">
        {heading}
      </h1>
      <div className="flex gap-2">
        <AdminFormFieldSubmit
          label={tMain("restore_to_default")}
          type="button"
          variant="primary"
          onClick={() => {
            dispatch(
              setModalsData({
                ...modalsState,
                showRestoreDefaultConfirmation: true,
              })
            );
          }}
          disabled={disabled}
        />
        {index !== 0 && (
          <AdminFormFieldSubmit
            label={
              <span className="flex justify-center items-center gap-2 whitespace-nowrap">
                {
                  <img
                    src={svgIcons.LeftArrowIcon}
                    alt={"left-icon"}
                    className="group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert"
                  />
                }
                {tMain("previous")}
              </span>
            }
            type="button"
            variant="primary"
            onClick={() => {
              dispatch(
                setModalsData({
                  ...modalsState,
                  showPreviousSaveConfirmation: true,
                })
              );
            }}
            disabled={disabled}
          />
        )}
        <AdminFormFieldSubmit
          label={tMain("save")}
          type="button"
          variant="primary"
          onClick={() => {
            handleSave();
          }}
          disabled={disabled}
        />
        {index !== 4 && (
          <AdminFormFieldSubmit
            label={
              <span className="flex justify-center items-center gap-2 whitespace-nowrap">
                {tMain("save_and_next")}
                {
                  <img
                    src={svgIcons.RightArrowIcon2}
                    alt={"right-icon"}
                    className="group-hover:grayscale-0 group-hover:brightness-0 group-hover:invert group-focus:grayscale-0 group-focus:brightness-0 group-focus:invert"
                  />
                }
                
              </span>
            }
            type="button"
            variant="primary"
            onClick={handleSaveAndNext}
            disabled={disabled}
          />
        )}
        {/* <img
          src={svgIcons.LeftArrowIcon}
          alt="left-arrow-icon"
          className={`p-2 rounded-full ${index === 0 ? "bg-gray-200 cursor-not-allowed" : "bg-accent-blue-pale cursor-pointer"}`}
          onClick={handleLeftNavigation}
        />
        <img
          src={svgIcons.RightArrowIcon2}
          alt="right-arrow-icon"
          className={`p-2 rounded-full ${index === 3 ? "bg-gray-200 cursor-not-allowed" : "bg-accent-blue-pale cursor-pointer"}`}
          onClick={handleRightNavigation}
        /> */}
      </div>
      <ModalPreviousSaveConfirmation
        handleSave={handlePrevious}
        handleLeftNavigation={handleLeftNavigation}
      />
      <ModalRestoreDefaultConfirmation handleRestore={handleRestoreToDefault} />
    </div>
  );
};

export default HeaderView;
